function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Art Wallet Register
 *    Scripts to register NFT wallet numbers against a user's order metafields.
 *
 *  Version:
 *    1.0.0 - 2021/09/15
 */

import { shopifyPost } from '@process-creative/slate-theme-tools';
import $ from 'jquery';
var METAFIELD_ENDPOINT = 'https://metafields-manager.thebestagency.com/proxy/metafield';
var SELECTOR_CONTAINER = '[data-wallet-register]';
var SELECTOR_PRODUCT = '[data-wallet-product]';
var SELECTOR_WALLET_FORM = '[data-wallet-form]';
var SELECTOR_WALLET_INPUT = '[data-wallet-number-input]';
var CLASS_ERROR = 'has-error';
var CLASS_HAS_NUMBER = 'has-wallet-number';
var ATTR_ORDER_ID = 'data-order-id';
var ATTR_LINE_KEY = 'data-line-key';
var ATTR_WALLET_NUMBERS = 'data-wallet-numbers';
var KEY_WALLET_METAFIELD = 'wallet-numbers';
var WalletRegister = /*#__PURE__*/function () {
  function WalletRegister(container) {
    var _this = this;
    _classCallCheck(this, WalletRegister);
    this.containerEl = container[0]; //JS Element
    this.orderId = this.containerEl.getAttribute(ATTR_ORDER_ID);
    this.walletNumbers = this.containerEl.getAttribute(ATTR_WALLET_NUMBERS);
    this.submittingForm = false;

    // Elements
    this.forms = this.containerEl.querySelectorAll(SELECTOR_WALLET_FORM);

    // Event Listeners
    this.forms.forEach(function (form) {
      form.removeAttribute('onsubmit');
      form.addEventListener('submit', function (e) {
        return _this.onFormSubmit(e);
      });
    });
  }
  _createClass(WalletRegister, [{
    key: "onMetafieldError",
    value: function onMetafieldError(form) {
      form.classList.add(CLASS_ERROR);
    }
  }, {
    key: "onMetafieldSuccess",
    value: function onMetafieldSuccess(form, input) {
      form.classList.add(CLASS_HAS_NUMBER);
      input.setAttribute('disabled', 'true');

      //Submit contact form to notify staff
      this.submitContactMessage(form);
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit(e) {
      console.log(this.submittingForm);
      console.log(e);
      if (this.submittingForm) return;
      e.preventDefault();
      e.stopPropagation();
      var form = e.target;
      var input = form.querySelector(SELECTOR_WALLET_INPUT);
      var value = input.value;
      if (!value) return input.classList.add(CLASS_ERROR);
      var product = form === null || form === void 0 ? void 0 : form.closest(SELECTOR_PRODUCT);
      var itemKey = product.getAttribute(ATTR_LINE_KEY);
      if (!product || !itemKey) throw 'Unexpected markup detected, please contact support.';

      //Current item wallet number, with item key and delimiter
      var itemWalletNumber = "".concat(itemKey, "__").concat(value.trim());

      //Existing item numbers + delimiter + current item number
      var newWalletNumbers = "".concat(this.walletNumbers ? "".concat(this.walletNumbers, "||") : "").concat(itemWalletNumber);
      this.postWalletMetafield(newWalletNumbers, form, input);

      //Saves existing submissions if multiple added on the same page load
      this.walletNumbers = newWalletNumbers;
    }
  }, {
    key: "submitContactMessage",
    value: function submitContactMessage(form) {
      this.submittingForm = true;
      //Shopify adds listners to the form submission stopping our
      //prevent default from working. This gets around the original submission.
      form.action = "/contact#".concat(form.id);
      form.method = 'post';
      form.submit();
    }
  }, {
    key: "postWalletMetafield",
    value: function postWalletMetafield(walletNumbersValue, form, input) {
      var _Shopify,
        _Shopify$shop,
        _this2 = this;
      var store = (_Shopify = Shopify) === null || _Shopify === void 0 ? void 0 : (_Shopify$shop = _Shopify.shop) === null || _Shopify$shop === void 0 ? void 0 : _Shopify$shop.replace('.myshopify.com', '');
      if (!store) throw 'Shopify store data missing, please contact support.';

      /**
       * Metafield Manager requires the metafield to be created with a matching key
       * and be set to "Allow this metafield to be updated from other domains."
       * This store's domain will also need to be whitelisted in the MM settings.
       */
      $.post(METAFIELD_ENDPOINT, {
        type: 'order',
        id: this.orderId,
        shop: store,
        namespace: 'global',
        key: KEY_WALLET_METAFIELD,
        value: walletNumbersValue
      }, function (response) {
        if (response.resp) {
          _this2.onMetafieldSuccess(form, input);
        } else if (response.status === 'error') {
          console.warn("There was an error submitting your request, please contact support. ".concat(response.message));
          _this2.onMetafieldError(status, form);
        }
      });
    }
  }]);
  return WalletRegister;
}();
$(function () {
  return $(SELECTOR_CONTAINER).each(function (i, e) {
    return new WalletRegister($(e));
  });
});